import axios from "axios";
import { API_URL } from "../../const";

export const getStatusCount = (statusData: any) => {
  const data = {
    StatusCountToken: statusData,
  };
  const url = `${API_URL}GetStatusCount`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

export const getAgents = (AgentData: any) => {
  const data = {
    GetAllLeadSourceToken: AgentData,
  };
  const url = `${API_URL}GetAllLeadSource`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
